import { Dashboard as Constants } from "../constants";
const initialState = {
  dashboard_data: [],
  loading: false,
};

export function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.DASHBOARD_SUCCESS:
      return {
        ...state,
        dashboard_data: action.payload,
      };

    case Constants.DASHBOARD_FAILED:
      return {
        ...state,
        loading: false,
      };

    case Constants.DASHBOARD_LOADING:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
}
